import { axiosClientv1 } from "./apiClient";
import { ApiResponse, ColorCode } from "../Types";

export const GetColorCodes = async (): Promise<ApiResponse<ColorCode[]>> => {
  try {
    const response = await axiosClientv1.get(`/color-codes/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load coloe codes.",
      data: [],
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const CreateColorCode = async (formData: {
  name: string;
  description?: string;
  status: string;
}): Promise<ApiResponse<ColorCode>> => {
  try {
    const response = await axiosClientv1.post(`/color-codes/create`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create color code.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const UpdateColorCode = async (formData: {
  id: string;
  name: string;
  description?: string;
  status: string;
}): Promise<ApiResponse<ColorCode>> => {
  try {
    const response = await axiosClientv1.post(`/color-codes/update`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update color code.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const DeleteColorCode = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/color-codes/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete color code.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};
